import Config from '../services/config';
var React = require('react'),
  withSideEffect = require('react-side-effect');

function reducePropsToState(propsList) {
  var innermostProps = propsList[propsList.length - 1];
  if (innermostProps) {
    return innermostProps.title;
  }
}

function handleStateChangeOnClient(title) {
  const titleSuffix = `${Config.name} | Relcore`;

  var nextTitle = title ? `${title} | ${titleSuffix}` : titleSuffix;

  if (nextTitle !== document.title) {
    document.title = nextTitle;
  }
}

interface IRelcoreDocumentTitleProps {
  title: string;
  children: any;
}

class RelcoreDocumentTitleComponent extends React.Component {
  props: IRelcoreDocumentTitleProps;

  render() {
    if (this.props.children) {
      return React.Children.only(this.props.children);
    } else {
      return null;
    }
  }
}

export default withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient
)(RelcoreDocumentTitleComponent);
